import {
  IMPORT_PATIENT_REQUEST,
  IMPORT_PATIENT_SUCCESS,
  IMPORT_PATIENT_FAIL,
  LIST_IMPORT_PATIENT_REQUEST,
  LIST_IMPORT_PATIENT_SUCCESS,
  LIST_IMPORT_PATIENT_FAIL,
  LIST_DETAIL_IMPORT_PATIENT_REQUEST,
  LIST_DETAIL_IMPORT_PATIENT_SUCCESS,
  LIST_DETAIL_IMPORT_PATIENT_FAIL,
  DETAIL_IMPORT_PATIENT_REQUEST,
  DETAIL_IMPORT_PATIENT_SUCCESS,
  DETAIL_IMPORT_PATIENT_FAIL,
  EXPORT_IMPORT_PATIENT_REQUEST,
  EXPORT_IMPORT_PATIENT_SUCCESS,
  EXPORT_IMPORT_PATIENT_FAIL,
  EXPORT_ALL_IMPORT_PATIENT_REQUEST,
  EXPORT_ALL_IMPORT_PATIENT_SUCCESS,
  EXPORT_ALL_IMPORT_PATIENT_FAIL,
  LIST_EXPORT_PATIENT_REQUEST,
  LIST_EXPORT_PATIENT_SUCCESS,
  LIST_EXPORT_PATIENT_FAIL,
  DOWNLOAD_EXPORT_PATIENT_REQUEST,
  DOWNLOAD_EXPORT_PATIENT_SUCCESS,
  DOWNLOAD_EXPORT_PATIENT_FAIL
} from '../../constants/patient-import'

const initialState = {
  loading: false,
  patientImport: [],
  detailPatientImport: {},
  detailPatientsImport: [],
  listPatientsExport: [],
  loadingDownload: false,
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const patientImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMPORT_PATIENT_REQUEST:
      return { ...state, loadingImport: true }
    case IMPORT_PATIENT_SUCCESS:
      return { ...state, loadingImport: false }
    case IMPORT_PATIENT_FAIL:
      return { ...state, loadingImport: false, error: action.payload }
    case LIST_IMPORT_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_IMPORT_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        patientImport: action.payload,
        pageable: action?.pageable
      }
    case LIST_IMPORT_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        patientImport: action?.dummy
      }
    case LIST_EXPORT_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_EXPORT_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        listPatientsExport: action.payload,
        pageable: action?.pageable
      }
    case LIST_EXPORT_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        listPatientsExport: []
      }
    case LIST_DETAIL_IMPORT_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_DETAIL_IMPORT_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        detailPatientsImport: action.payload,
        pageable: action.pageable
      }
    case LIST_DETAIL_IMPORT_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        detailPatientsImport: action?.dummy
      }
    case DETAIL_IMPORT_PATIENT_REQUEST:
      return { ...state, loading: true }
    case DETAIL_IMPORT_PATIENT_SUCCESS:
      return { ...state, loading: false, detailPatientImport: action.payload }
    case DETAIL_IMPORT_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        detailPatientImport: action?.dummy
      }
    case EXPORT_IMPORT_PATIENT_REQUEST:
      return { ...state, loadingExport: true }
    case EXPORT_IMPORT_PATIENT_SUCCESS:
      return { ...state, loadingExport: false }
    case EXPORT_IMPORT_PATIENT_FAIL:
      return { ...state, loadingExport: false, error: action.payload }
    case EXPORT_ALL_IMPORT_PATIENT_REQUEST:
      return { ...state, loadingExport: true }
    case EXPORT_ALL_IMPORT_PATIENT_SUCCESS:
      return { ...state, loadingExport: false }
    case EXPORT_ALL_IMPORT_PATIENT_FAIL:
      return { ...state, loadingExport: false, error: action.payload }
    case DOWNLOAD_EXPORT_PATIENT_REQUEST:
      return {
        ...state,
        loadingDownload: true,
        error: null
      }
    case DOWNLOAD_EXPORT_PATIENT_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        error: null
      }
    case DOWNLOAD_EXPORT_PATIENT_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default patientImportReducer
